import { Eye, X } from "react-feather";
import styles from "./tenantdetails.module.css";
import { Dialog, DialogContent, Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useState } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";

const TenantDetails = ({ prospectData, setLoading, expanded, handleChange, tenantId, tenantIdNew, leases }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [docUrl, setDocUrl] = useState("");
    const [openDocModal, setOpenDocModal] = useState(false);

    const viewDocumnet2 = async (id) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/get-tenant-document/" + id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setOpenDocModal(true);
            setDocUrl(response.data.data?.file_url);
        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const viewCreditReport = async (tenantInfoId) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/get-report-link/" + tenantInfoId, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            window.open(response?.data?.url);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<Accordion expanded={expanded === "panel22"} onChange={handleChange("panel22")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel22bh-content" id="panel22bh-header">
            <div className={`${styles.FormAccoHead}`}>
                <p className={`${styles.FormAccoHeadTitlePro}`}>Tenant Details</p>
            </div>
        </AccordionSummary>
        <AccordionDetails>
            <div className={`${styles.SMScoreCardDe}`}>
                <p className={`${styles.SMScoreCardDeTitle}`}>Personal Information</p>
                <ul>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Referral:</span>
                        <span className={`${styles.SMProDE}`}>
                            {prospectData?.referral_name !== "" ? prospectData?.referral_name : "-"}
                        </span>
                    </li>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Lease Term:</span>
                        <Link to={"/leases/details/" + tenantIdNew} className={`${styles.SMProDE}`}>{dayjs(leases?.start_date).format("MM/DD/YYYY")}{" "}-{" "}{dayjs(leases?.end_date).format("MM/DD/YYYY")}</Link>
                    </li>
                    {prospectData?.document_type !== "" && (<li>
                        <span className={`${styles.SMProDETag}`}>Verification:</span>
                        <a href="/" className={`${styles.SMProDE}`} onClick={(e) => { e.preventDefault(); viewDocumnet2(tenantId); }}>
                            <Eye />
                            {prospectData?.document_type === "passport" && "Passport"}
                            {prospectData?.document_type === "id_card" && "Id Card"}
                            {prospectData?.document_type === "driving_license" && "Driver License"}
                        </a>
                    </li>)}
                    <li>
                        <span className={`${styles.SMProDETag}`}>Credit Score:</span>
                        <span className={`${styles.SMProDE}`}>
                            {prospectData?.reportPDF !== "" ? (<>
                                <a href="/" className={`${styles.SMProDE}`} onClick={(e) => { e.preventDefault(); viewCreditReport(tenantId); }}>
                                    <Eye />
                                    {prospectData?.credit_score}
                                </a>
                                <img src="/static/img/verified.svg" className={`${styles.Varified}`} alt="" />
                            </>) : prospectData?.credit_score !== "" ? (prospectData?.credit_score) : ("-")}
                        </span>
                    </li>
                    {prospectData?.income_type === "Voucher" ? (<li>
                        <span className={`${styles.SMProDETag}`}>Voucher:</span>
                        <span className={`${styles.SMProDE}`}>
                            {prospectData?.voucher_amount !== "" ? prospectData?.voucher_amount : "-"}
                        </span>
                    </li>) : (<li>
                        <span className={`${styles.SMProDETag}`}>Salary:</span>
                        <span className={`${styles.SMProDE}`}>
                            {prospectData?.income_per_year !== "" ? "$" + prospectData?.formatted_income_per_year : "-"}
                        </span>
                    </li>)}
                    <li>
                        <span className={`${styles.SMProDETag}`}>Bankruptcy:</span>
                        <span className={`${styles.SMProDE}`}>
                            {prospectData?.ever_had_bankruptcy !== "" ? prospectData?.ever_had_bankruptcy : "-"}
                        </span>
                    </li>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Housing Court Cases:</span>
                        <span className={`${styles.SMProDE}`}>
                            {prospectData?.ever_case_filed !== "" ? prospectData?.ever_case_filed : "-"}
                        </span>
                    </li>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Current Monthly Rent:</span>
                        <span className={`${styles.SMProDE}`}>
                            {prospectData?.current_rent !== "" ? "$" + prospectData?.formatted_current_rent : "-"}
                        </span>
                    </li>
                </ul>
            </div>
            <div className={`${styles.SMScoreCardDe}`}>
                <p className={`${styles.SMScoreCardDeTitle}`}>Preferences</p>
                <ul>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Move-In Date:</span>
                        <span className={`${styles.SMProDE}`}>
                            {prospectData?.move_in_date !== "" ? dayjs(prospectData?.move_in_date).format("MM/DD/YYYY") : "-"}
                        </span>
                    </li>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Bedrooms:</span>
                        <span className={`${styles.SMProDE}`}>
                            {prospectData?.bedrooms !== "" ? prospectData?.bedrooms : "-"}
                        </span>
                    </li>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Bathrooms:</span>
                        <span className={`${styles.SMProDE}`}>
                            {prospectData?.bathrooms > 0 ? prospectData?.bathrooms : "-"}
                        </span>
                    </li>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Pets:</span>
                        <span className={`${styles.SMProDE}`}>
                            {prospectData?.have_pets !== "" && prospectData?.have_pets !== "0" ? prospectData?.have_pets : "-"}
                        </span>
                    </li>
                    <li>
                        <span className={`${styles.SMProDETag}`}>Smoke:</span>
                        <span className={`${styles.SMProDE}`}>
                            {prospectData?.do_you_smoke !== "" ? prospectData?.do_you_smoke : "-"}
                        </span>
                    </li>
                </ul>
            </div>
            <Dialog
                onClose={(e) => { setOpenDocModal(false); setDocUrl(""); }}
                aria-labelledby="customized-dialog-title"
                open={openDocModal}
                className="NewPopUp NewPopUpForLease"
            >
                <button onClick={(e) => { setOpenDocModal(false); setDocUrl(""); }} className={`${styles.IDImageCloseBU}`}><X /></button>
                <DialogContent>
                    <div className={`${styles.IDImageSec}`}>
                        <img src={docUrl} className={`${styles.IDImage}`} alt="" />
                    </div>
                </DialogContent>
            </Dialog>
        </AccordionDetails>
    </Accordion>);
};

export default TenantDetails;